// extracted by mini-css-extract-plugin
export default {"placeholder":"AddingFormSaleType_placeholder__6F5E3","placeHolderShimmer":"AddingFormSaleType_placeHolderShimmer__V4lfB"};